module.exports = __webpack_public_path__ + "static/media/ntg60map.0b03b24c.jpg";